import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "TumiBackLogin" }
const _hoisted_2 = { class: "TumiLogin" }
const _hoisted_3 = { class: "TumiForm" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "LogoTumi",
  class: "TumiLogoLola"
}, null, -1)
const _hoisted_5 = { class: "mt-4 text-white" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" You're email has been confirmed! Click ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("here")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" to log in. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_ctx.confirmed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_RouterLink, {
                    to: '/Login',
                    class: "TumiOrange"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
          ])
        ])
      ])
    ])
  ]))
}